import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
  text-align: center;
`;

export const RecordingBullet = styled.span`
  display: inline-block;
  background-color: rgb(236, 17, 17);
  width: 15px;
  height: 15px;
  border-radius: 50%;
  animation: recording .8s ease-in-out infinite;
  margin-right: 7px;
`;

export const Button = styled.button`
  text-align: center;
  background-color: transparent;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: .1s;
  &:hover {
    transform: scale(1.15);
    color: #fff;
  }
`;

export const StopButton = styled(Button)`
  && {
    width: 30px;
    height: 30px;
  }
  border: solid 1px rgb(236, 17, 17);
  color: rgb(236, 17, 17);
  &:hover {
    background-color: rgb(236, 17, 17);
  }
`;

export const SendButton = styled(Button)`
  && {
    width: 30px;
    height: 30px;
  }
  border: solid 1px rgb(36, 163, 148);
  color: rgb(36, 163, 148);
  &:hover {
    background-color: rgb(36, 163, 148);
  }
`;

export const Timer = styled.span`
  font-size: 20px; 
  color: #6a6a6a;
  display: inline;
`;

export const ButtonWrapper = styled.div<{flex?: string}>`
  display: flex;
  justify-content: flex-${props => props.flex};
  svg {
    font-size: 17px;
    align-self: center;
  }
`;